import { render, staticRenderFns } from "./CardRow.vue?vue&type=template&id=93723698&scoped=true"
import script from "./CardRow.vue?vue&type=script&lang=js"
export * from "./CardRow.vue?vue&type=script&lang=js"
import style0 from "./CardRow.vue?vue&type=style&index=0&id=93723698&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93723698",
  null
  
)

export default component.exports